import { type ComponentPropsWithoutRef, type FC, type ReactNode } from 'react'

import { LABELS } from '@/constants/common/message.constants'
import { cn } from '@/utils/tailwind.utils'

type Props = ComponentPropsWithoutRef<'div'> & {
  /** オーバーレイのアクション */
  actions: ReactNode
  /** 選択中の件数 */
  selectedLength: number
  /** 追加で表示したい要素 */
  extra?: ReactNode
}

export const Overlay: FC<Props> = ({
  actions,
  selectedLength,
  className,
  extra,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn([
        'absolute inset-0 flex w-full items-center bg-primary py-2 pl-4 text-white',
        className
      ])}
    >
      <div className="-mt-0.5 w-[50px]">
        <div className="flex-1 whitespace-pre-line pl-1 text-xs leading-[14px]">
          <b className="text-sm">{selectedLength}</b>{' '}
          {LABELS.ITEMS_SELECTED_SUFFIX}
        </div>
      </div>
      {extra && <div className="flex items-center pl-2">{extra}</div>}
      <div className="flex items-center">{actions}</div>
    </div>
  )
}
